(function (Drupal, once) {
  /**
   * Cohesion field token replacement for dynamic classes.
   * Maps components from cohCanvases structure and replaces [field.XXX] tokens
   * in class attributes with actual field values from the component's model data.
   */
  Drupal.behaviors.cohesionDynamicClasses = {
    attach(context) {
      // Use window.drupalSettings directly
      if (typeof window === "undefined" || !window.drupalSettings) {
        return;
      }

      const drupalSettings = window.drupalSettings;

      // Extract cohCanvases data from cohesion.cohCanvases
      if (!drupalSettings.cohesion || !drupalSettings.cohesion.cohCanvases) {
        return;
      }

      const cohCanvases = drupalSettings.cohesion.cohCanvases;

      // Map to store component UUIDs and their field values
      // Structure: { componentUuid: { fieldUuid: value } }
      const componentFieldValues = {};

      // Process each canvas
      Object.keys(cohCanvases).forEach((canvasKey) => {
        const canvas = cohCanvases[canvasKey];
        if (!canvas.canvas || !canvas.model) {
          return;
        }

        // Recursively map all components from canvas structure
        const componentMap = {};
        function mapComponents(items) {
          if (!Array.isArray(items)) {
            return;
          }
          items.forEach((item) => {
            // If it's a component with a UUID, add it to the map
            if (item.type === "component" && item.uuid) {
              componentMap[item.uuid] = item;
            }
            // Recursively process children
            if (item.children && Array.isArray(item.children)) {
              mapComponents(item.children);
            }
          });
        }

        mapComponents(canvas.canvas);

        // Map field values for each component from model
        Object.keys(componentMap).forEach((componentUuid) => {
          const componentModel = canvas.model[componentUuid];
          if (componentModel && typeof componentModel === "object") {
            componentFieldValues[componentUuid] = {};

            // Extract field values from component model
            Object.keys(componentModel).forEach((key) => {
              // Skip special keys like 'settings'
              if (key === "settings") {
                return;
              }

              const fieldValue = componentModel[key];
              // Handle different value types
              if (fieldValue !== null && fieldValue !== undefined) {
                // If it's an object (like color picker), extract the relevant value
                if (typeof fieldValue === "object") {
                  // For color picker, use the class or rgba value
                  if (fieldValue.class) {
                    componentFieldValues[componentUuid][key] =
                      fieldValue.class.replace(/^\./, "");
                  } else if (fieldValue.rgba) {
                    componentFieldValues[componentUuid][key] = fieldValue.rgba;
                  } else if (fieldValue.value) {
                    // For nested value objects
                    componentFieldValues[componentUuid][key] =
                      typeof fieldValue.value === "object"
                        ? fieldValue.value.hex || fieldValue.value.rgba
                        : fieldValue.value;
                  } else {
                    // For other objects, try to stringify or use a default
                    componentFieldValues[componentUuid][key] =
                      String(fieldValue);
                  }
                } else {
                  // Simple value (string, number, boolean)
                  componentFieldValues[componentUuid][key] = fieldValue;
                }
              }
            });
          }
        });
      });

      // Find all elements with [field.XXX] tokens in their class attribute
      once("cohesionDynamicClasses", '[class*="[field."]', context).forEach(
        function (element) {
          // Extract all [field.XXX] tokens from the element's class attribute
          const classList = element.className;
          const tokenRegex = /\[field\.([a-f0-9-]+)\]/gi;
          const tokens = [];
          let match;

          while ((match = tokenRegex.exec(classList)) !== null) {
            const fieldUuid = match[1];
            const fullToken = match[0];
            if (!tokens.find((t) => t.uuid === fieldUuid)) {
              tokens.push({ uuid: fieldUuid, fullToken });
            }
          }

          if (tokens.length === 0) {
            return;
          }

          // Find the component UUID associated with this element
          // Look for coh-component-instance-{uuid} or ssa-component-instance-{uuid} class
          let componentUuid = null;
          let currentElement = element;

          // First, check if the element itself has the component class
          const componentClassRegex =
            /(?:coh|ssa)-component-instance-([a-f0-9-]+)/i;
          let classMatch = classList.match(componentClassRegex);

          // If not found, traverse up the DOM tree to find the component
          while (!classMatch && currentElement) {
            const parentClasses = currentElement.className || "";
            classMatch = parentClasses.match(componentClassRegex);
            if (classMatch) {
              break;
            }
            currentElement = currentElement.parentElement;
          }

          if (classMatch) {
            componentUuid = classMatch[1];
          }

          // If still not found, try to find by traversing up to find any component instance
          if (!componentUuid) {
            currentElement = element.parentElement;
            while (currentElement && !componentUuid) {
              const classes = currentElement.className || "";
              const match = classes.match(componentClassRegex);
              if (match) {
                componentUuid = match[1];
                break;
              }
              currentElement = currentElement.parentElement;
            }
          }

          if (!componentUuid) {
            // Component UUID not found, skip this element
            return;
          }

          // Get field values for this specific component
          const componentFields = componentFieldValues[componentUuid];
          if (!componentFields) {
            // Component not found in model, skip
            return;
          }

          // Replace tokens in the element's class attribute
          let newClassList = classList;
          tokens.forEach(function (token) {
            const value = componentFields[token.uuid];

            // Convert value to string for replacement
            let replacement = "";
            if (value !== null && value !== undefined) {
              replacement = String(value);
            }

            // Replace the token with the value (global replace for multiple occurrences)
            newClassList = newClassList.replace(
              new RegExp("\\[field\\." + token.uuid + "\\]", "g"),
              replacement,
            );
          });

          // Clean up extra spaces and update the element's class
          newClassList = newClassList.trim().replace(/\s+/g, " ");

          if (newClassList !== classList) {
            element.className = newClassList;
          }
        },
      );
    },
  };
})(Drupal, once);
